<template>
<div class="civii-cancelaccept">
  <div @click="$emit('accept')" :class="acceptClass" />
  <div @click="$emit('cancel')" :class="cancelClass" />
</div>
</template>

<script>
export default {
  props: {
    type: {type: String, default: 'cancelaccept'}
  },
  computed: {
    type_ () {
      return this.type || 'cancelaccept'
    },
    acceptClass () {
      let icon
      if (this.type_ === 'cancelaccept') icon = 'check'
      else if (this.type_ === 'negativepositive') icon = 'thumb_up'
      return [
        'civii-icon-' + icon,
        'civii-cancelaccept-accept'
      ]
    },
    cancelClass () {
      let icon
      if (this.type_ === 'cancelaccept') icon = 'chattimes-light'
      else if (this.type_ === 'negativepositive') icon = 'thumb_down'
      return [
        'civii-icon-' + icon,
        'civii-cancelaccept-cancel'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/CancelAccept/CancelAccept.vue